var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetakeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-344 -123)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(344 123)",
    fill: "#dae0e7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(349 128)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.056 8.752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.672,3.931a12.033,12.033,0,0,0-17.439-.4L2.117,1.411,0,9.274,7.862,7.056,5.746,4.939a10.053,10.053,0,1,1,.6,14.818h0a10.14,10.14,0,0,1-3.427-5.846,1.046,1.046,0,0,0-1.21-.806,1.046,1.046,0,0,0-.806,1.21A11.783,11.783,0,0,0,5.04,21.37h0a12.1,12.1,0,0,0,16.632-1.109h0A12.085,12.085,0,0,0,21.672,3.931Z",
    transform: "translate(0 0.015)",
    fill: "#0d1c4b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetakeIcon);
export default __webpack_public_path__ + "static/media/retake-icon.77bade4a496c8de625c60dfa3539e98b.svg";
export { ForwardRef as ReactComponent };